import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearUser, updateUser } from "../../Components/redux/userSlice";
import { clearFavourites } from "../../Components/redux/favouritesSlice";
import { clearCart } from "../../Components/redux/cartItemsSlice";
import { clearLocations } from "../../Components/redux/locationsSlice";
import { clearComments } from "../../Components/redux/commentsSlice";
import { toast } from "react-toastify";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    id: user.id,
    name: user.name,
    surname: user.surname,
    email: user.email,
    password: user.password,
  });

  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!user.isLoggedIn) {
      navigate("/");
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSave = () => {
    axios
      .put("https://www.elzabeauty.az/elza/users.php", formData, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        if (res.data.status === 1) {
          dispatch(updateUser(formData)); // ✅ Redux'u güncelle
          setMessage("Bilgiler güncellendi.");
          toast.success(t("Hesab məlumatlarınız uğurla yeniləndi"));
        } else {
          setMessage("Güncelleme başarısız.");
        }
      })
      .catch(() => {
        setMessage("Sunucu hatası.");
      });
  };

  const handleLogout = () => {
    dispatch(clearUser());
    dispatch(clearFavourites());
    dispatch(clearCart());
    dispatch(clearLocations());
    dispatch(clearComments());
    navigate("/");
  };

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto flex justify-center items-center bg-gray-100 pt-10 md:pt-20">
      <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-container">
        <h2 className="text-[24px] md:text-[24px] font-semibold text-center text-gray-800 mb-8">
          {t("Profil Məlumatları")}
        </h2>

        <div className="space-y-6">
          <div>
            <label className="block text-gray-700 text-sm font-medium mb-2">
              {t("Ad")}
            </label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              placeholder={t("Adınızı daxil edin")}
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-medium mb-2">
              {t("Soyad")}
            </label>
            <input
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              placeholder={t("Soyadınızı daxil edin")}
            />
          </div>

          <div>
            <label className="block text-gray-700 text-sm font-medium mb-2">
              {t("Email")}
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              readOnly
              className="w-full text-gray-600 border border-gray-300 rounded-lg px-4 py-2 cursor-not-allowed"
            />
          </div>

          <div className="relative">
            <label className="block text-gray-700 text-sm font-medium mb-2">
              {t("Şifrə")}
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              placeholder={t("Yeni şifrə daxil edin")}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-[39px] text-gray-500 hover:text-gray-700"
            >
              {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </button>
            <p className="text-sm text-red-500 mt-2">
              {t("Şifrə dəyişikliyi müəyyən zaman ala bilər.")}
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-4">
          <button
            onClick={handleSave}
            className="bg-[#181D27] hover:bg-[#0f1218] text-white px-6 py-2 rounded-lg transition"
          >
            {t("Yadda saxla")}
          </button>
          <button
            onClick={handleLogout}
            className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg transition"
          >
            {t("Çıxış")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
